export default __webpack_public_path__ + "static/media/politicalScience.b54a792a.svg";